import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=61f16720&scoped=true"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"
import style0 from "./addTask.vue?vue&type=style&index=0&id=61f16720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f16720",
  null
  
)

export default component.exports